<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12" style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <label for="cameraFileInput">
                        <div class="dotCamera">
                            <v-icon class="photoIcon" color="#059BCA" style="font-size: 22svw">
                                photo_camera</v-icon>
                        </div>
                        <input id="cameraFileInput" type="file" accept="image/png, image/jpeg" capture="environment" />
                    </label>
                    <p
                        style="margin-top: 4.84svh; font-family: Lato; font-style: normal; color: #3F616C; font-size: 20px; font-weight: 400;">
                        Hacer foto última deposición </p>
                    <v-card style="margin-top: 6svh; margin-left: 3.6svw; margin-right: 3.6svw; border: 1px solid #059BCA; border-radius: 9px; box-shadow: none">
                        <v-row>
                            <v-col cols="3" style="padding: 0; display: flex">
                                <v-icon style="margin: auto;" medium color="#059BCA">
                                    error_outline</v-icon>
                            </v-col>
                            <v-col cols="9" style="padding: 0; margin-top: 1svh; margin-bottom: 1svh">
                                <p style="margin-top: 8%; margin-left: 0%; margin-right: 0%; margin-bottom: 0%; font-family: Lato; font-style: normal; color: #059BCA; text-align: left; font-size: 13px; font-weight: 400;">
                                    Procurar buena iluminación en WC
                                </p>
                                <p style="margin-top: 0%; margin-left: 0%; margin-right: 0%; margin-bottom: 0%; font-family: Lato; font-style: normal; color: #059BCA; text-align: left; font-size: 13px; font-weight: 400;">
                                    Preferiblemente WC blanco
                                </p>
                                <p style="margin-top: 0%; margin-left: 0%; margin-right: 0%; margin-bottom: 8%; font-family: Lato; font-style: normal; color: #059BCA; text-align: left; font-size: 13px; font-weight: 400;">
                                    Fotografiar a 50 cm. del WC
                                </p>
                            </v-col>
                        </v-row>
                    </v-card>
                    <div style="display: flex; align-items: flex-end; flex: 1 1 auto">
                      <v-btn elevation="12" v-on:click="click()"
                          style="margin-left: auto; margin-right: auto; margin-bottom: 7.66svh; width: 147px; height: 49px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                          <b>Ver ejemplo</b>
                      </v-btn>
                    </div>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import CardNav from './CardNav.vue';
import { nextScreen } from '../router/utils.js';
import router from '../router';
import { preference } from "vue-preferences";

export default {
    name: 'LastDeposited',
    components: {
        CardNav
    },
    methods: {
        savePhoto() {
            // TODO: add a generic try catch to capture any error that may happen when taking the picture
            let photoUpload = document.getElementById("cameraFileInput");
            let filename = "";
            let fileBase64Url = "";
            photoUpload.onchange = function () {
                filename = photoUpload.files[0].name;
                fileBase64Url = photoUpload.files[0];
                const filenamePref = preference('filename', { defaultValue: '' });
                filenamePref.set(filename);
                const fileBase64UrlPref = preference('fileBase64Url', { defaultValue: '' });
                // Create an Object URL from the selected file URL (or the picture the user just took). This is not in Base64 yet.
                fileBase64UrlPref.set(URL.createObjectURL(fileBase64Url));

                setTimeout(() => {
                        router.push('/photoupload');
                    }, 250);
            };
        },
        click() {
            nextScreen(this.$router, '/firstexample');
        },
    },
    mounted() {
        this.savePhoto();
    }
}
</script>

<style>
#cameraFileInput {
    display: none;
}

.dotCamera {
    box-sizing: border-box;
    margin-left: calc((100svw - 49svw - 2svw - 2svw) / 2);
    margin-top: 6.25svh;
    height: 49svw;
    width: 49svw;
    background-color: #FFFFFF;
    border-radius: 50%;
    display: flex;
    cursor: pointer;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.50);
    border: 1px solid #059BCA;
}

.photoIcon {
    margin: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/LastDeposited.vue